import {
  Avatar,
  Box,
  ButtonBase,
  CardContent,
  ClickAwayListener,
  Fade,
  IconButton,
  Paper,
  Popper,
  Stack,
  Tab,
  Tabs,
  Typography,
  useTheme,
} from "@mui/material";
import MainCard from "components/MainCard";
import ProfileTab from "layouts/Header/HeaderContent/Profile/ProfileTab";
import SwitchTheme from "layouts/Header/HeaderContent/Profile/SwitchTheme";
import React from "react";
import { useRef } from "react";
import { useState } from "react";
import { AiOutlineUser } from "react-icons/ai";
import { IoSettingsOutline } from "react-icons/io5";
import { TbLogout } from "react-icons/tb";
import { useDispatch, useSelector } from "react-redux";
import { logoutAction } from "store/reducers/auth";
import SettingsTab from "../Settings/SettingsTab";

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`profile-tabpanel-${index}`}
      aria-labelledby={`profile-tab-${index}`}
      {...other}
    >
      {value === index && children}
    </div>
  );
}

function Profile() {
  const theme = useTheme();
  const anchorRef = useRef(null);
  const iconBackColorOpen =
    theme.palette.mode === "light" ? "grey.300" : "background.default";
  const [open, setOpen] = useState(false);
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };
  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth?.user);
  return (
    <Box sx={{ ml: 0.75 }}>
      <ButtonBase
        sx={{
          p: 0.5,
          bgcolor: open ? iconBackColorOpen : "transparent",
          borderRadius: 1,
          "&:hover": { bgcolor: "primary.lighter" },
        }}
        ref={anchorRef}
        onClick={handleToggle}
      >
        <Stack direction="row" alignItems="center" spacing={1} sx={{ p: 0.5 }}>
          <Avatar sx={{ width: 32, height: 32, bgcolor: "warning.main" }}>
            {user.user[0]}
          </Avatar>
          <Typography variant="subtitle1">{user.user}</Typography>
        </Stack>
      </ButtonBase>
      <Popper
        placement="bottom-end"
        open={open}
        anchorEl={anchorRef.current}
        transition
        disablePortal
        popperOptions={{
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [0, 12],
              },
            },
          ],
        }}
      >
        {({ TransitionProps }) => (
          <Fade in={open} {...TransitionProps}>
            <Paper
              sx={{
                boxShadow: theme.customShadows.z1,
                width: 290,
                minWidth: 240,
                maxWidth: 290,
                [theme.breakpoints.down("md")]: {
                  maxWidth: 250,
                },
              }}
            >
              <ClickAwayListener onClickAway={handleClose}>
                <MainCard elevation={0} border={false} content={false}>
                  <CardContent sx={{ px: 2.5, pt: 3 }}>
                    <Stack justifyContent="space-between" direction="row">
                      <Stack direction="row" spacing={1.25} alignItems="center">
                        <Avatar
                          sx={{
                            width: 32,
                            height: 32,
                            bgcolor: "warning.main",
                          }}
                        >
                          {user.user[0]}
                        </Avatar>
                        <Stack>
                          <Typography variant="h6">{user.user}</Typography>
                          <Typography variant="body2" color="textSecondary">
                            Role : {user.roles[0]}
                          </Typography>
                        </Stack>
                      </Stack>
                      <IconButton
                        size="large"
                        onClick={() => dispatch(logoutAction())}
                      >
                        <TbLogout />
                      </IconButton>
                    </Stack>
                  </CardContent>
                  {open && (
                    <>
                      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                        <Tabs
                          variant="fullWidth"
                          value={value}
                          onChange={handleChange}
                          aria-label="profile tabs"
                        >
                          <Tab
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "center",
                              alignItems: "center",
                              textTransform: "capitalize",
                            }}
                            icon={
                              <AiOutlineUser
                                style={{ marginBottom: 0, marginRight: "10px" }}
                              />
                            }
                            label="Profile"
                            {...a11yProps(0)}
                          />
                          <Tab
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "center",
                              alignItems: "center",
                              textTransform: "capitalize",
                            }}
                            icon={
                              <IoSettingsOutline
                                style={{ marginBottom: 0, marginRight: "10px" }}
                              />
                            }
                            label="Setting"
                            {...a11yProps(1)}
                          />
                        </Tabs>
                      </Box>
                      <TabPanel value={value} index={0} dir={theme.direction}>
                        <ProfileTab />
                      </TabPanel>
                      <TabPanel value={value} index={1} dir={theme.direction}>
                        <SettingsTab />
                      </TabPanel>
                      <Stack
                        justifyContent="center"
                        direction="row"
                        sx={{ mb: 1.5 }}
                      >
                        <SwitchTheme />
                      </Stack>
                    </>
                  )}
                </MainCard>
              </ClickAwayListener>
            </Paper>
          </Fade>
        )}
      </Popper>
    </Box>
  );
}

export default Profile;
